import { Box, Container, Tab, Tabs } from "@mui/material";
import React, { useState, useEffect } from "react";
import { ProfileTab } from "../components/organisms/ProfileTab";
import { AccountTab } from "../components/organisms/AccountTab";
import { SubscriptionTab } from "../components/organisms/SubscriptionTab";
import { EmailVerificationModal } from "../components/molecules/EmailVerificationModal";
import { useAuth } from "../contexts/AuthContext";

// Settings tab enum
enum SettingsTab {
  PROFILE = 0,
  ACCOUNT = 1,
  SUBSCRIPTION = 2,
}

const SettingsPage: React.FC = () => {
  const { user, refreshAuth } = useAuth();
  const [currentTab, setCurrentTab] = useState<SettingsTab>(
    SettingsTab.SUBSCRIPTION,
  );
  const [showVerificationModal, setShowVerificationModal] = useState(false);

  const handleTabChange = (_: React.SyntheticEvent, newValue: SettingsTab) => {
    setCurrentTab(newValue);
  };

  // Check if user needs email verification on mount
  useEffect(() => {
    if (user && user.emailVerified === false) {
      setShowVerificationModal(true);
    }
  }, [user]);

  const handleEmailVerified = async () => {
    await refreshAuth();
    setShowVerificationModal(false);
  };

  return (
    <Container maxWidth="lg">
      <Box sx={{ minHeight: "80vh", py: 4 }}>
        <Tabs
          value={currentTab}
          onChange={handleTabChange}
          centered
          sx={{ mb: 3 }}
        >
          <Tab label="Profile" value={SettingsTab.PROFILE} />
          <Tab label="Account" value={SettingsTab.ACCOUNT} />
          <Tab label="Subscription" value={SettingsTab.SUBSCRIPTION} />
        </Tabs>

        {currentTab === SettingsTab.PROFILE && <ProfileTab />}
        {currentTab === SettingsTab.ACCOUNT && <AccountTab />}
        {currentTab === SettingsTab.SUBSCRIPTION && <SubscriptionTab />}
      </Box>

      {/* Email Verification Modal - Non-dismissible for unverified users */}
      <EmailVerificationModal
        open={showVerificationModal}
        onClose={() => setShowVerificationModal(false)}
        email={user?.email || ""}
        onVerified={handleEmailVerified}
        disableClose={true}
        isEmailChange={false}
      />
    </Container>
  );
};

export default SettingsPage;
